import React from 'react';
import { Input } from 'antd';
import {
  FormContainer,
  FormItemContainer,
  FormLabel as StyledFormLabel,
  FullWidthInputNumber,
} from '../Styles';
import { NewOptionData } from './types';

interface OptionFormProps {
  newOptionData: NewOptionData;
  handleNewOptionDataChange: (field: string, value: any) => void;
}

export const OptionForm: React.FC<OptionFormProps> = ({
  newOptionData,
  handleNewOptionDataChange,
}) => {
  return (
    <FormContainer>
      <FormItemContainer>
        <StyledFormLabel>Option Name *</StyledFormLabel>
        <Input
          placeholder="Option Name"
          value={newOptionData.option}
          onChange={(e) => handleNewOptionDataChange('option', e.target.value)}
        />
      </FormItemContainer>

      <FormItemContainer>
        <StyledFormLabel>Description</StyledFormLabel>
        <Input
          placeholder="Description"
          value={newOptionData.description}
          onChange={(e) => handleNewOptionDataChange('description', e.target.value)}
        />
      </FormItemContainer>

      <FormItemContainer>
        <StyledFormLabel>Price *</StyledFormLabel>
        <FullWidthInputNumber
          placeholder="Price"
          value={newOptionData.price ? parseFloat(newOptionData.price) : undefined}
          onChange={(value) => handleNewOptionDataChange('price', value?.toString() || '')}
          min={0}
          step={0.01}
        />
      </FormItemContainer>
    </FormContainer>
  );
};

